import React, { useCallback } from "react";
import { AccrualDocumentsCompact } from "@components/documents/AccrualDocuments/AccrualDocumentsCompact";
import {
    useLinkDocumentsToBill,
    useUnlinkDocumentsFromBill,
} from "@api/bill.api";
import { useScope } from "@state/scopeContext.lib";

interface BillDocumentsCompactProps {
    billId: string;
    financialDocumentIds?: number[];
}

export const BillDocumentsCompact: React.FC<BillDocumentsCompactProps> = ({
    billId,
    financialDocumentIds,
}) => {
    const { workspaceId } = useScope();
    const linkMutation = useLinkDocumentsToBill();
    const unlinkMutation = useUnlinkDocumentsFromBill();

    const onLinkDocuments = useCallback(
        (documentIds: number[], options: { onError: () => void }) => {
            if (!workspaceId) {
                options.onError();
                return;
            }
            linkMutation.mutate(
                { workspaceId, billId, financialDocumentIds: documentIds },
                { onError: options.onError },
            );
        },
        [workspaceId, billId, linkMutation],
    );

    const onRemoveDocument = useCallback(
        (documentId: number, options: { onError: () => void }) => {
            if (!workspaceId) {
                options.onError();
                return;
            }
            unlinkMutation.mutate(
                { workspaceId, billId, financialDocumentIds: [documentId] },
                { onError: options.onError },
            );
        },
        [workspaceId, billId, unlinkMutation],
    );

    return (
        <AccrualDocumentsCompact
            financialDocumentIds={financialDocumentIds}
            onLinkDocuments={onLinkDocuments}
            onRemoveDocument={onRemoveDocument}
        />
    );
};
